module.exports = __webpack_public_path__ + "static/intelectBunk-40a6ef1761244ac4a86bcea0882bfe73.png";